import type { SentimentPolarity } from '@up2stay/up2promo-api-client';

/** Which reply state the inbox lists — drives the segmented tabs. */
export type ReviewsInboxTab = 'open' | 'answered' | 'all';

export type ReviewsFilterValues = {
  tab: ReviewsInboxTab;
  locationIds: string[];
  sentiments: SentimentPolarity[];
  aspects: string[];
  ratings: number[];
};

export type ReviewsLocationOption = { id: string; name: string };
export type ReviewsAspectOption = { key: string; label: string };

export function createDefaultReviewsFilters(
  overrides?: Partial<ReviewsFilterValues>,
): ReviewsFilterValues {
  return {
    tab: 'open',
    locationIds: [],
    sentiments: [],
    aspects: [],
    ratings: [],
    ...overrides,
  };
}

/** Chip filters only — the tab is a mode, not a filter. */
export function countActiveChipFilters(value: ReviewsFilterValues): number {
  return (
    value.locationIds.length +
    value.sentiments.length +
    value.aspects.length +
    value.ratings.length
  );
}

export function toggleInArray<T>(items: T[], item: T): T[] {
  return items.includes(item)
    ? items.filter((value) => value !== item)
    : [...items, item];
}
